export const THEME_PALETTE = {
    ttmsBlue: "#183EC9",
    ttmsLightBlue: "#A0C4FF",
};

export const THEMES = {
    LIGHT: "LIGHT",
    DARK: "DARK",
};
export const THEME_DICTIONARY = {
    [THEMES.LIGHT]: 'light',
    [THEMES.DARK]: 'dark',
};
export const ACCEPTED_THEMES = [THEME_DICTIONARY.LIGHT, THEME_DICTIONARY.DARK];